export default __webpack_public_path__ + "static/vehicle-card-default-photo~JzylAAlB-110e18778c0adeb54da5503aec8ad326.jpg";